<template>
  <v-container fluid class="pa-0" style="height: 100%">
    <v-card flat class="rounded-0" :class="!valid && !loading ? 'ErrorBorder' : null">

      <v-container class="d-flex px-2 py-2">
        <v-row no-gutters>
          <v-col cols="auto">
            <v-btn color="close" class="mr-2" icon @click="close()">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-col>
          <v-col :cols="0" class="mr-4 my-auto">
            <h3 v-text="IsNew ? 'New address' : 'Edit address'" class="useThemeTextColor" />
          </v-col>
        </v-row>
      </v-container>

      <v-form v-model="valid">
        <v-container class="px-4 pb-2 pt-0" v-if="editObject">
          <v-row no-gutters>
            <v-col v-if="error" cols="12" class="mb-3">
              <v-card :color="error.StatusCode >= 500 ? 'error' : 'warning'" dark class="px-2 py-1" flat>
                <v-icon size="14" class="mr-1">mdi-alert</v-icon>
                {{ error.Message || 'Error' }}
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <QTextField v-model="editObject.Name" :label="$t('servicesystem.common_objects.address.name')"
                externaledit>
              </QTextField>
            </v-col>
            <v-col cols="12">
              <QTextField v-model="editObject.Street" :label="$t('servicesystem.common_objects.address.street')"
                :rules="[requiredRule]" externaledit>
              </QTextField>
            </v-col>
            <v-col cols="4">
              <QTextField v-model="editObject.Zip" :label="$t('servicesystem.common_objects.address.zip')"
                :rules="[requiredRule]" externaledit>
              </QTextField>
            </v-col>
            <v-col cols="8" class="pl-3">
              <QTextField v-model="editObject.City" :label="$t('servicesystem.common_objects.address.city')"
                :rules="[requiredRule]" externaledit>
              </QTextField>
            </v-col>
            <v-col cols="12">
              <QTextField v-model="editObject.Country" :label="$t('servicesystem.common_objects.address.country')"
                externaledit>
              </QTextField>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-4">
            <v-col cols="auto">
              <v-btn icon color="close" @click="close()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
            <v-col></v-col>
            <!--
            <v-col cols="auto"
                   v-if="!IsNew">
              <v-btn icon
                     :color="IsChanged ? 'tertiary' : 'disabled'"
                     @click="setEditObject()">
                <v-icon>mdi-undo-variant</v-icon>
              </v-btn>
            </v-col>
            -->
            <v-col></v-col>
            <v-col cols="auto">
              <v-btn icon :color="IsSaveable ? 'quaternary' : 'disabled'" @click="IsSaveable ? save() : null" :loading="loading" :disabled="loading">
                <v-icon v-if="!loading">mdi-check</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>

    </v-card>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";

export default {
  name: "AddressEdit",
  props: {
    CustomerId: [String, Number],
    Address: Object,
    AddressList: Array,
  },
  components: {},
  mixins: [clientAPI],

  data: () => ({
    editObject: null,
    valid: false,
    loading: false,
    error: null,
  }),

  mounted() {

    this.setEditObject();
  },

  methods: {
    save() {
      this.error = null;
      this.loading = true;
      const methodname = this.IsNew ? "createCustomerAdress" : "changeCustomerAdressById";
      const emitname = this.IsNew ? "Created" : "Changed";
      var a = Object.assign({}, this.editObject);
      const dto = { Id: a.Id, CustomerId: this.CustomerId, Address: a };
      this[methodname](dto)
        .then((response) => {
          console.log("Response", response);
          this.$emit(emitname, Object.assign({}, response));
          this.close();
        })
        .catch((e) => {
          this.error = e;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    close() {
      this.$emit("Close");
    },

    setEditObject() {
      if (this.Address && Object.keys(this.Address).length) {
        this.editObject = Object.assign({}, this.Address);
        this.editObject.Id = this.getMergeId();
      } else {
        this.editObject = { Id: null, CustomerId: this.CustomerId, IsActive: true };
      }
    },

    getMergeId() {
      var mergetarget = this.Address?.Id;
      //if Id is null or undefined, try to find matching address in AddressList
      //this occurs on older jobs created before addressId field was added to the job enity
      if (mergetarget == null && this.Address != null) {
        mergetarget = this.AddressList?.find(
          (x) =>
            x.Name == this.Address.Name &&
            x.Street == this.Address.Street &&
            x.Zip == this.Address.Zip &&
            x.Country == this.Address.Country &&
            x.Country == this.Address.Country
        );
        mergetarget = mergetarget?.Id;
      }

      return mergetarget;
    },
  },

  computed: {
    IsNew() {
      return !this.editObject || !this.editObject.Id;
    },

    IsChanged() {
      var compareTemp = Object.assign({}, this.Address);
      compareTemp.Id = this.getMergeId();
      return !this.SameValue(compareTemp, this.editObject);
    },

    IsSaveable() {
      return this.valid && !this.loading && this.IsChanged;
    },
  },

  watch: {
    CustomerId: function () {
      this.setEditObject();
    },
    Address: function () {
      this.setEditObject();
    },
  },
};
</script>


<style lang="scss" scoped>
.ErrorBorder {
  border: 1px solid var(--v-error-base);
}
</style>